import { VeterinarianOfficeUser } from '@/models/DTO/veterinarian-office-user/veterinarian-office-user.model';
import { BaseAPIService } from './base-api.service';
import { Inject, injectable } from 'inversify-props';
import { VeterinarianOfficeUserUpdateRequest } from '@/models/DTO/veterinarian-office-user/veterinarian-office-user-update-request.model';

export interface VeterinarianOfficeUsersService {
  getById(id: string): Promise<VeterinarianOfficeUser>;
  update(
    model: VeterinarianOfficeUserUpdateRequest
  ): Promise<VeterinarianOfficeUser>;
  lockoutVeterinarianOfficeUser(id: string): Promise<void>;
  unlockVeterinarianOfficeUser(id: string): Promise<void>;
}

const API_VERSION: string = process.env.VUE_APP_API_VERSION;
const VETERINARIAN_OFFICE_USER_STUB_URL = `/api/v${API_VERSION}/VeterinarianOfficeUsers`;
const LOCKOUT_VETERINARIAN_OFFICE_USER_URL = `${VETERINARIAN_OFFICE_USER_STUB_URL}/LockOutVeterinarianOfficeUsers/:id`;
const UNLOCK_VETERINARIAN_OFFICE_USER_URL = `${VETERINARIAN_OFFICE_USER_STUB_URL}/UnlockVeterinarianOfficeUsers/:id`;

@injectable()
export class VeterinarianOfficeUsersService
  implements VeterinarianOfficeUsersService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async getById(id: string): Promise<VeterinarianOfficeUser> {
    const resp = await this._baseAPIService.client.get<VeterinarianOfficeUser>(
      `${VETERINARIAN_OFFICE_USER_STUB_URL}/${id}`
    );
    return resp.data;
  }

  public async update(
    model: VeterinarianOfficeUserUpdateRequest
  ): Promise<VeterinarianOfficeUser> {
    const resp = await this._baseAPIService.client.put<VeterinarianOfficeUser>(
      `${VETERINARIAN_OFFICE_USER_STUB_URL}/${model.id}`,
      {
        ...model
      }
    );

    return resp.data;
  }

  public async lockoutVeterinarianOfficeUser(id: string): Promise<void> {
    const url = LOCKOUT_VETERINARIAN_OFFICE_USER_URL.replace(':id', id);
    await this._baseAPIService.client.post(url);
  }

  public async unlockVeterinarianOfficeUser(id: string): Promise<void> {
    const url = UNLOCK_VETERINARIAN_OFFICE_USER_URL.replace(':id', id);
    await this._baseAPIService.client.post(url);
  }
}
